import { render, staticRenderFns } from "./EvaluationAuditTab.vue?vue&type=template&id=2b6d6020&"
import script from "./EvaluationAuditTab.vue?vue&type=script&lang=js&"
export * from "./EvaluationAuditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports